import React from 'react';
import { NavLink } from 'react-router-dom';
import '../../styles/sidebar.css';
import spartaLogo from '../../assets/img/sparta_logo_v1.png';
import appConfig from '../../config';

const NAV = [
  { section: 'Workspace' },
  { label: 'Overview',          icon: '⬡', to: '/' },
  { section: 'Analytics' },
  { label: 'Fleet Registry',    icon: '✈', to: '/fleet' },
  { label: 'Utilisation',       icon: '📊', to: '/utilisation' },
  { label: 'Flights',           icon: '✈️', to: '/flights' },
  { label: 'MRO & Maintenance', icon: '🔧', to: '/mro' },
  { label: 'Lifecycle & Risk',  icon: '⚠️', to: '/risk', badge: true },
  { label: 'Operator History',  icon: '📋', to: '/history' },
];

export default function Sidebar({ riskCount = 0 }) {
  return (
    <nav className="sidebar">
      <div className="sb-logo">
        <div className="sb-logo-inner">
          <div className="sb-lbox">
            <a href={appConfig.domain.subDomian} className='sparta-logo'>
              <img src={spartaLogo} alt='logo' />
            </a>
          </div>
          <div>
            <div className="sb-ltag">Fleet Analytics</div>
          </div>
        </div>
      </div>

      <div className="sb-nav">
        {NAV.map((item, i) => {
          if (item.section) {
            return <div key={i} className="sb-section">{item.section}</div>;
          }
          return (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              className={({ isActive }) => 'sb-item' + (isActive ? ' active' : '')}
            >
              <span className="sb-icon">{item.icon}</span>
              {item.label}
              {item.badge && riskCount > 0 && (
                <span className="sb-badge">{riskCount}</span>
              )}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
